import { FunctionComponent } from "react"
import Col from "react-bootstrap/Col"
import Container from "react-bootstrap/Container"
import Row from "react-bootstrap/Row"
import PrivateComponent from "../components/PrivateComponent"
import RoutersCard from "../components/RoutersCard"
import ScriptsCard from "../components/ScriptsCard"
import TemplatesCard from "../components/TemplatesCard"
import { Group } from "../data/models"

interface IHomePage {}
const HomePage: FunctionComponent<IHomePage> = () => {
	return (
		<Container>
			<h2 className="text-center mt-4">Norhart Internet Management</h2>
			<Row xs={1} md={2} lg={3} className="g-4 mt-4">
				<PrivateComponent groups={[Group.InternetManagement, Group.InternetManagementManager, Group.InternetManagementAdmin, Group.GlobalAdmin]}>
					<Col>
						<RoutersCard />
					</Col>
				</PrivateComponent>
				<PrivateComponent groups={[Group.InternetManagementAdmin, Group.GlobalAdmin]}>
					<Col>
						<TemplatesCard />
					</Col>
				</PrivateComponent>
				<PrivateComponent groups={[Group.InternetManagementManager, Group.InternetManagementAdmin, Group.GlobalAdmin]}>
					<Col>
						<ScriptsCard />
					</Col>
				</PrivateComponent>
			</Row>
		</Container>
	)
}
export default HomePage
